import { render, staticRenderFns } from "./OneTimeCodeForgotContainer.vue?vue&type=template&id=f7e86a76&scoped=true&"
import script from "./OneTimeCodeForgotContainer.vue?vue&type=script&lang=ts&"
export * from "./OneTimeCodeForgotContainer.vue?vue&type=script&lang=ts&"
import style0 from "./OneTimeCodeForgotContainer.vue?vue&type=style&index=0&id=f7e86a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e86a76",
  null
  
)

export default component.exports